// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0add4daf8ec40c43a045","5677":"3a35394cbf9b8f5881db"}[chunkId] + ".css";
};